function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Mousewheel } from 'swiper';
import styles from "./QuoteSlice.module.scss";
import { QuoteCard } from "../../QuoteCard/QuoteCard";
import { Button } from "../../Button/Button/Button";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var QuoteSlice = function QuoteSlice(_ref) {
  var headerText = _ref.headerText,
    cards = _ref.cards,
    button = _ref.button;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    forceUpdate = _useState2[1];
  var swiperRef = useRef(null);
  var validCards = cards || [];
  var middleIndex = Math.floor(validCards.length / 2);
  var handleSwiper = function handleSwiper(swiper) {
    swiperRef.current = swiper;
    setTimeout(function () {
      swiper.update();
      swiper.slideTo(middleIndex, 0);
    }, 0);
  };
  useEffect(function () {
    if (!swiperRef.current) return;
    var forceCenter = function forceCenter() {
      if (swiperRef.current) {
        swiperRef.current.update();
        swiperRef.current.slideTo(middleIndex, 0);
      }
    };
    var timer1 = setTimeout(forceCenter, 100);
    var timer2 = setTimeout(forceCenter, 300);
    var timer3 = setTimeout(forceCenter, 500);
    return function () {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [middleIndex]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [headerText && /*#__PURE__*/_jsx("div", {
      className: styles.headerText,
      children: headerText
    }), /*#__PURE__*/_jsx("div", {
      className: styles.cardsContainer,
      children: /*#__PURE__*/_jsx(Swiper, {
        modules: [Mousewheel],
        spaceBetween: 20,
        slidesPerView: "auto",
        centeredSlides: true,
        initialSlide: middleIndex,
        loop: false,
        speed: 600,
        slideToClickedSlide: true,
        onSwiper: handleSwiper,
        onSlideChange: function onSlideChange() {
          return forceUpdate(function (n) {
            return n + 1;
          });
        },
        className: styles.swiper,
        mousewheel: {
          forceToAxis: true
        },
        children: validCards.map(function (cardData, index) {
          return /*#__PURE__*/_jsx(SwiperSlide, {
            className: styles.slide,
            children: function children(_ref2) {
              var isActive = _ref2.isActive,
                isNext = _ref2.isNext,
                isPrev = _ref2.isPrev;
              var levelClass = isActive ? styles.level1 : isNext || isPrev ? styles.level2 : styles.level3;
              var level = isActive ? 1 : isNext || isPrev ? 2 : 3;
              return /*#__PURE__*/_jsx("div", {
                className: levelClass,
                children: /*#__PURE__*/_jsx(QuoteCard, _objectSpread(_objectSpread({}, cardData), {}, {
                  level: level
                }))
              });
            }
          }, index);
        })
      })
    }), button && /*#__PURE__*/_jsx("div", {
      className: styles.buttonContainer,
      children: /*#__PURE__*/_jsx(Button, _objectSpread({}, button))
    })]
  });
};